import { defineStore } from 'pinia'
import {ref, computed} from 'vue'


export const usePhotoStore = defineStore(
	"photo",
	() => {
		const photo = ref(false)
		// const ninety_eight = ref(false)
	},
)